import { combineReducers } from "redux";
import login from "./login";
import home from "./home";
import usersCompaniesManagement from "./usersCompaniesManagement";
import cancelReservation from "./cancelReservation";
import dayRateAvailability from "./dayRateAvailability";
import rateplanManagement from "./rateplanManagement";
import globalRatePlanManagement from "./globalRatePlanManagement";

export default combineReducers({
  login,
  home,
  usersCompaniesManagement,
  cancelReservation,
  dayRateAvailability,
  rateplanManagement,
  globalRatePlanManagement
});
